import PropTypes from 'prop-types';
import React from 'react';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import classnames from 'classnames';

import t from '../../lib/I18n';

export default class CheckboxWrapper extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        label: PropTypes.any,
        helpIcon: PropTypes.any,
        helpLink: PropTypes.string,
        labelClassName: PropTypes.string,
        groupClassName: PropTypes.string,
        darkBackground: PropTypes.bool,
        inline: PropTypes.bool,
        autoFocus: PropTypes.bool,
        srOnly: PropTypes.string,
        error: PropTypes.string
    };

    static defaultProps = {
        className: '',
        label: null,
        helpIcon: null,
        helpLink: null,
        labelClassName: null,
        groupClassName: null,
        darkBackground: false,
        inline: false,
        autoFocus: false,
        srOnly: '',
        error: ''
    };

    /*
     * Only use an alternate SR label if you're happy for everything inside
     *  the original label to be aria-hidden. Don't use if, for example,
     *  it includes a HelpIcon whose aria-label should be read out.
     */

    render () {
        const { className, label, helpIcon, helpLink, groupClassName, labelClassName, darkBackground, inline, srOnly, error, ...props } = this.props;
        const errorMessage = error ? t(error) : '';
        const groupClassNames = classnames(groupClassName, {
            'checkbox-inline': inline,
        });
        const classNames = classnames(className, {
            'checkbox--invalid': error,
            'checkbox--dark-bg': darkBackground,
        });

        if (srOnly) {
            return (
                <div className={ groupClassNames }>
                    <Checkbox className={ classNames } { ...props }>
                        <span className={ labelClassName } aria-hidden="true">{ label }</span>
                        {(helpIcon && helpLink) && <a href={helpLink}>{ helpIcon }</a>}
                        <span className="sr-only">{ error ? `Error: ${errorMessage}. ` : '' }{ srOnly }</span>
                    </Checkbox>
                </div>
            );
        }
        return (
            <div className={ groupClassNames }>
                <Checkbox className={ classNames } { ...props }>
                    <span className={ labelClassName }>{ label }</span>
                </Checkbox>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/form/Checkbox.js